<template>
  <div>
    <div class="input-placeholder text-ordinary mb-1">{{ title }}</div>
    <div class="paragraph-m_h font-600"><slot /></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
}>();

defineSlots<{
  default: () => void;
}>();
</script>

<style scoped lang="scss"></style>
